import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import { Divider, Flex } from '@/components/base';
import useColor from '@/hooks/domain/useColor';
import type { DETAIL_MODAL_TYPE } from '@/stores/pure/DetailModalStore';

import { FeedbackDeleteAction } from './Actions/FeedbackDeleteAction';
import { FeedbackLinkCopyAction } from './Actions/FeedbackLinkCopyAction';
import { FeedbackCloseAction } from './Actions/FeedbackLinkCopyAction';
import { FeedbackNavigationActions } from './Actions/FeedbackNavigationActions';

type Props = {
  feedbackAlias: string;
  closeModal: () => void;
  onSelectNewModal: (alias: string, type: DETAIL_MODAL_TYPE) => void;
  toPrevFeedback: () => void;
  toNextFeedback: () => void;
};

const FeedbackDetailActions = (props: Props) => {
  const color = useColor();
  const params = useParams();
  const location = useLocation();
  const isFeedbackPage = useMemo(() => {
    return location.pathname === `/workspace/${params.workspace_id}/feedbacks`;
  }, [location.pathname, params.workspace_id]);

  return (
    <Flex>
      {isFeedbackPage && (
        <Flex a="center">
          <FeedbackNavigationActions
            toPrevFeedback={props.toPrevFeedback}
            toNextFeedback={props.toNextFeedback}
            isFeedbackPage={isFeedbackPage}
          />
          <Divider
            direction="v"
            style={{ height: 16, color: color.gray250, margin: '0 8px' }}
          />
        </Flex>
      )}
      <Flex g="6px" a="center">
        <FeedbackDeleteAction feedbackAlias={props.feedbackAlias} />
        <FeedbackLinkCopyAction feedbackAlias={props.feedbackAlias} />
        <FeedbackCloseAction closeModal={props.closeModal} />
      </Flex>
    </Flex>
  );
};

export default FeedbackDetailActions;
